/**
 * @architecture-header 1
 * @layer module-ui
 * @domain settings-sso
 * @responsibility Render the SET-F07 SSO & Security pane from the already-shared workspace session.
 * @state-owner app SessionProvider
 * @allowed-imports same-module components; app session provider
 * @forbidden direct API client; TanStack Query; any new operation
 * @public-api SsoSettingsPage
 * @side-effects none
 * @tests SsoSettingsSurface.test.tsx
 */

import { useWorkspaceSession } from '../../../app/providers/SessionProvider';
import { SsoSettingsSurface } from './SsoSettingsSurface';

export function SsoSettingsPage({ mobile }: { mobile: boolean }) {
  const { session } = useWorkspaceSession();
  return <SsoSettingsSurface linkedProviders={session?.linkedProviders ?? []} mobile={mobile} />;
}
